import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-56ef43d0"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  ref: "editorBox"
};
const _hoisted_2 = {
  class: "project-client-detail-bottom"
};
const _hoisted_3 = {
  key: 0,
  class: "risk-info"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "risk-info-tit"
}, "发货与售后", -1));
const _hoisted_5 = {
  class: "risk-info-cont"
};
const _hoisted_6 = {
  key: 1,
  class: "risk-info-3c"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "3C认证证书", -1));
const _hoisted_8 = {
  key: 1,
  class: "risk-info urgent_notices"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "risk-info-tit"
}, "温馨提示", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Error = _resolveComponent("Error");
  return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, null, 512), _createElementVNode("div", _hoisted_2, [$data.risk || $data.certificate_ccc_id ? (_openBlock(), _createElementBlock("div", _hoisted_3, [$data.risk ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [_hoisted_4, _createElementVNode("div", _hoisted_5, _toDisplayString($data.risk), 1)], 64)) : _createCommentVNode("", true), $data.certificate_ccc_id ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_hoisted_7, _createElementVNode("div", {
    class: "click-div",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.showCertificateCcc && $options.showCertificateCcc(...args))
  }, "点击查看")])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), $data.urgent_notices ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_hoisted_9, _createElementVNode("div", null, _toDisplayString($data.urgent_notices), 1)])) : _createCommentVNode("", true)]), $data.showError ? (_openBlock(), _createBlock(_component_Error, {
    key: 0,
    message: $data.showMessage
  }, null, 8, ["message"])) : _createCommentVNode("", true)]);
}